'use client';

import { useEffect, useRef } from 'react';
import { isNil } from 'es-toolkit';

/**
 * Wrapper for inactive (archived) households to prevent interactions with fields that may affect the household
 * information, as archived households are immutable. This is to have a better UX, as any requests would actually fail.
 */
export function InactiveHouseholdOverlayWrapper({ children }: { readonly children: React.ReactNode }) {
  const childrenRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const el = childrenRef.current;
    if (isNil(el)) return;
    el.setAttribute('inert', '');
    return () => el.removeAttribute('inert');
  }, []);

  return (
    <div className="relative">
      <div className="relative z-0" ref={childrenRef}>
        {children}
      </div>
      <div className="absolute inset-0 bg-white/50 z-1 outline-none" tabIndex={0} />
    </div>
  );
}
